import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { mediaQueries } from '@blocket/blazar-plugins-device'
import { colors } from '@blocket/blocket-ui'

const ResponsivePageWrapper = styled.main`
  display: flex;
  justify-content: center;
  margin-top: 2px;
  background-color: ${colors.white100};
  padding: 24px;

  /* IE11 workaround, do not remove! */
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    width: 100%;
  }
`

const ContentWrapper = styled.div`
  max-width: ${({ mobileMaxWidth }) => mobileMaxWidth}px;

  @media ${mediaQueries.large} {
    max-width: ${({ desktopMaxWidth }) => desktopMaxWidth}px;
  }
`

const ResponsivePage = ({ mobileMaxWidth = 480, desktopMaxWidth = 480, children, className }) => (
  <ResponsivePageWrapper className={className}>
    <ContentWrapper mobileMaxWidth={mobileMaxWidth} desktopMaxWidth={desktopMaxWidth}>
      {children}
    </ContentWrapper>
  </ResponsivePageWrapper>
)

ResponsivePage.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  mobileMaxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  desktopMaxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default ResponsivePage
